/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface SSRRuleQuery
 */
export interface SSRRuleQuery {
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof SSRRuleQuery
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof SSRRuleQuery
     */
    carrier?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {string}
     * @memberof SSRRuleQuery
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SSRRuleQuery
     */
    showDeleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SSRRuleQuery
     */
    showDisabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SSRRuleQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SSRRuleQuery
     */
    limit?: number | null;
}

export function SSRRuleQueryFromJSON(json: any): SSRRuleQuery {
    return SSRRuleQueryFromJSONTyped(json, false);
}

export function SSRRuleQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SSRRuleQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'carrier': !exists(json, 'carrier') ? undefined : GuidIdCodeAndLabelFromJSON(json['carrier']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'showDeleted': !exists(json, 'showDeleted') ? undefined : json['showDeleted'],
        'showDisabled': !exists(json, 'showDisabled') ? undefined : json['showDisabled'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function SSRRuleQueryToJSON(value?: SSRRuleQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'carrier': GuidIdCodeAndLabelToJSON(value.carrier),
        'description': value.description,
        'showDeleted': value.showDeleted,
        'showDisabled': value.showDisabled,
        'offset': value.offset,
        'limit': value.limit,
    };
}


